import React, { useEffect, useState } from 'react';
import {
  Input,
  DatePicker,
  Radio,
  NumberPicker,
  TimePicker,
  Search,
} from '@alifd/next';
import moment from 'moment';
import ConfirmDialog from '@/components/Dialog/ConfirmDialog';
import styles from './index.module.scss';
import { Servlets } from '@/service';
import TopTitle from '@/components/UI/TopTitle';

const BaseDetail = [
    {
        type: 'title',
        name: '添加短信标题',
        content: '',
        draggable: false,
        canDelete: false,
        clicked: true,
        isUpload: false,
    },
    {
        type: 'content',
        name: '短信签名+文本内容+退订',
        content: '',
        draggable: true,
        canDelete: false,
        clicked: false,
        isUpload: false,
    }
];

const CheckInput = (props) => {
  // 是否展示类型修改提示弹窗
  const [typeDialogTip, setTypeDialogTip] = useState(false);
  const RadioGroup = Radio.Group;
  const { RangePicker, MonthPicker, YearPicker } = DatePicker;
  // 保证执行一次useeffect
  const [isDone, setSsDone] = useState(false);
  // 默认活动起止时间
  const [activityTime, setActivityTime] = useState();

  // 设置禁止选择的时间
  const disabledDate = function (date, view) {
    return (
      moment().subtract(0, 'day').valueOf() > date.valueOf() ||
      date.valueOf() > moment().add(Number(expriedDays), 'days')
    );
  };
  // 账户天数余额
  const [expriedDays, setExpriedDays] = useState();
  useEffect(() => {
    setSsDone(true);
    // props.setPo(poList);
    //  获取软件订购剩余天数
      Servlets('getTitle', {}).then((res: { data: string }) => {
        setExpriedDays(res.data?.remainingDay);
        // setExpriedDays(30);
      });
  }, []);

  const disabledItems = (list) => (index) => {
    return list.indexOf(index) >= 0;
  };

  const changesendStrategy = (v) => {
    props.setBaseInfo({ ...props.params, sendStrategy: v });
  };
  // 改变发送类型
  const changeType = () => {
      props.setBaseInfo({ ...props.params, smsType: props.params.smsType === 1 ? 2 : 1, smsContent: '', smsShortUrl: '', smsLongUrl: '', smsModelId: -1, detail: [...BaseDetail], testMobilesShow: null });
      setTypeDialogTip(false);
  };

  return (
    <div
      style={{
        marginBottom: '20px',
        background: 'white',
        padding: '20px',
        borderRadius: '5px',
      }}
    >
      <TopTitle title="基础信息" />
      <div className={styles.baseInfoContent}>
        <div className={styles.baseInfoLeft}>
          {props.showPolist ? (
            <div style={{ display: 'flex', marginBottom: '15px' }}>
              <div
                style={{
                  width: '30%',
                  height: '30px',
                  lineHeight: '30px',
                  textAlign: 'right',
                  paddingRight: '10px',
                }}
              >
                <span>
                  <span className={styles.mustFill}>*</span>PO选择：
                </span>
              </div>
              <div style={{ width: '70%' }}>
                {Number(props.checkType) !== 3 ? (
                  <Search
                    dataSource={props.poList}
                    followTrigger
                    placeholder="请输入PO号"
                    onChange={(value) => {
                      const temp = { ...props.params };
                      temp.smsPoNum = value;
                      props.setBaseInfo(temp);
                    }}
                    value={props.params.smsPoNum}
                    shape="simple"
                    style={{ width: '90%' }}
                  />
                ) : (
                  <Search
                    disabled
                    dataSource={props.poList}
                    value={props.params.smsPoNum}
                    shape="simple"
                    style={{ width: '90%' }}
                  />
                )}
              </div>
            </div>
          ) : (
            ''
          )}

          <div style={{ display: 'flex', marginBottom: '15px' }}>
            <div
              style={{
                width: '30%',
                height: '30px',
                lineHeight: '30px',
                textAlign: 'right',
                paddingRight: '10px',
              }}
            >
              <span>
                <span className={styles.mustFill}>*</span>活动名称：
              </span>
            </div>
            <div style={{ width: '70%' }}>
              {Number(props.checkType) !== 3 ? (
                <Input
                  trim
                  className={styles.nameInput}
                  maxLength={32}
                  placeholder="请输入活动名称"
                  showLimitHint
                  aria-label="input max length 32"
                  value={props.params.taskName}
                  style={{ width: '90%' }}
                  onChange={(v) => {
                    const temp = { ...props.params };
                    temp.taskName = v;
                    temp.taskName = v;
                    props.setBaseInfo(temp);
                  }}
                />
              ) : (
                <Input
                  className={styles.nameInput}
                  maxLength={32}
                  placeholder="请输入活动名称"
                  disabled
                  showLimitHint
                  aria-label="input max length 32"
                  value={props.params.taskName}
                  style={{ width: '90%' }}
                />
              )}
            </div>
          </div>

          <div style={{ display: 'flex', marginBottom: '15px' }}>
            <div
              style={{
                width: '30%',
                height: '30px',
                lineHeight: '30px',
                textAlign: 'right',
                paddingRight: '10px',
              }}
            >
              <span>活动描述：</span>
            </div>
            <div style={{ width: '70%' }}>
              {Number(props.checkType) !== 3 ? (
                <Input
                  className={styles.nameInput}
                  maxLength={32}
                  placeholder="请输入活动描述"
                  showLimitHint
                  aria-label="input max length 32"
                  value={props.params.taskDesc}
                  style={{ width: '90%' }}
                  onChange={(v) => {
                    const temp = { ...props.params };
                    props.setBaseInfo({
                      ...temp,
                      taskDesc: v,
                    });
                  }}
                />
              ) : (
                <Input
                  className={styles.nameInput}
                  maxLength={32}
                  placeholder="请输入活动描述"
                  showLimitHint
                  disabled
                  aria-label="input max length 32"
                  value={props.params.taskDesc}
                  style={{ width: '90%' }}
                  onChange={(v) => {
                    const temp = { ...props.params };
                    props.setBaseInfo({
                      ...temp,
                      taskDesc: v,
                    });
                  }}
                />
              )}
            </div>
          </div>

          <div style={{ display: 'flex', marginBottom: '15px' }}>
            <div
              style={{
                width: '30%',
                height: '30px',
                lineHeight: '30px',
                textAlign: 'right',
                paddingRight: '10px',
              }}
            >
              <span>
                <span className={styles.mustFill}>*</span>活动起止时间：
              </span>
            </div>
            <div style={{ width: '70%' }}>
              {Number(props.checkType) !== 3 ? (
                <RangePicker
                  format="YYYY-MM-DD"
                  placeholder="请选择起止时间"
                  onChange={(v) => {
                    const temp = { ...props.params };
                    if (v.length === 0) {
                      temp.taskStartTime = '';
                      temp.taskEndTime = '';
                    }
                    if (v[0]) {
                      temp.taskStartTime = v[0]._d.getTime();
                    }
                    if (v[1]) {
                      temp.taskEndTime = v[1]._d.getTime();
                    }
                    props.setTimevalue(v);
                    setActivityTime(v);
                    props.setBaseInfo(temp);
                  }}
                  className={styles.setTimeDate}
                  style={{ width: '90%' }}
                  value={props.timevalue}
                  disabledDate={disabledDate}
                  followTrigger
                  popupAlign="tl bl"
                />
              ) : (
                <RangePicker
                  format="YYYY-MM-DD"
                  disabled
                  placeholder="请选择起止时间"
                  className={styles.setTimeDate}
                  style={{ width: '90%' }}
                  value={props.timevalue}
                />
              )}
            </div>
          </div>

          <div style={{ display: 'flex', marginBottom: '15px' }}>
            <div
              style={{
                width: '30%',
                height: '30px',
                lineHeight: '30px',
                textAlign: 'right',
                paddingRight: '10px',
              }}
            >
              <span>
                <span className={styles.mustFill}>*</span>每次短信投放时间点：
              </span>
            </div>
            <div style={{ width: '70%' }}>
              {Number(props.checkType) !== 3 ? (
                <TimePicker
                  followTrigger
                  placeholder="请选择投放时间点"
                  disabledHours={disabledItems([
                    0, 1, 2, 3, 4, 5, 6, 7, 8, 20, 21, 22, 23,
                  ])}
                  value={moment(
                    moment().startOf('day')._d.getTime() +
                      props.params.sendTime
                  )}
                  // value = {props.params.sendTime}
                  format="H:mm"
                  onChange={(v) => {
                    const temp = { ...props.params };
                    if (v) {
                      temp.sendTime =
                        Number(moment(v._d.getTime()).format('HH')) * 3600000 +
                        Number(moment(v._d.getTime()).format('mm')) * 60000;
                    } else {
                      temp.sendTime = '';
                    }
                    props.setBaseInfo(temp);
                  }}
                  className={styles.setTimeDate}
                  style={{ width: '90%' }}
                />
              ) : (
                <TimePicker
                  placeholder="请选择投放时间点"
                  disabled
                  value={moment(
                    moment().startOf('day')._d.getTime() +
                      props.params.sendTime
                  )}
                  format="H:mm"
                  className={styles.setTimeDate}
                  style={{ width: '90%' }}
                />
              )}
            </div>
          </div>

          <div style={{ display: 'flex', marginBottom: '15px' }}>
            <div
              style={{
                width: '30%',
                height: '30px',
                lineHeight: '30px',
                textAlign: 'right',
                paddingRight: '10px',
              }}
            >
              <span>
                <span className={styles.mustFill}>*</span>投放策略：
              </span>
            </div>
            <div style={{ width: '70%' }}>
              {Number(props.checkType) !== 3 ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Radio
                    id="now"
                    checked={+props.params.sendStrategy !== 0}
                    className={styles.rightNow}
                    style={{ marginRight: '10%' }}
                    onClick={() => {
                      changesendStrategy(1);
                    }}
                  >
                    在预测时间前
                    <NumberPicker
                      min={1}
                      max={750}
                      style={{
                        width: '50px',
                        marginLeft: '5px',
                        marginRight: '5px',
                      }}
                      value={
                        +props.params.sendStrategy === 0
                          ? ''
                          : props.params.sendStrategy
                      }
                      disabled={+props.params.sendStrategy === 0}
                      onChange={(v) => {
                        changesendStrategy(v);
                      }}
                    />
                    天推送
                  </Radio>
                  <Radio
                    id="setTime"
                    checked={+props.params.sendStrategy === 0}
                    onClick={() => {
                      props.setBaseInfo({ ...props.params, sendStrategy: 0 });
                    }}
                  >
                    在预测时间当天推送
                  </Radio>
                </div>
              ) : (
                <div style={{ display: 'flex' }}>
                  <Radio
                    id="now"
                    disabled
                    className={styles.rightNow}
                    checked={+props.params.sendStrategy !== 0}
                    style={{ marginRight: '10%' }}
                  >
                    在预测时间前
                    <Input
                      disabled
                      value={
                        +props.params.sendStrategy === 0
                          ? ''
                          : props.params.sendStrategy
                      }
                      style={{
                        width: '50px',
                        marginLeft: '5px',
                        marginRight: '5px',
                      }}
                    />
                    天推送
                  </Radio>
                  <Radio
                    id="setTime"
                    checked={+props.params.sendStrategy === 0}
                    disabled
                  >
                    在预测时间当天推送
                  </Radio>
                </div>
              )}
            </div>
          </div>

          <div style={{ display: 'flex', marginBottom: '15px' }}>
            <div
              style={{
                width: '30%',
                height: '30px',
                lineHeight: '30px',
                textAlign: 'right',
                paddingRight: '10px',
              }}
            >
              <span>
                <span className={styles.mustFill}>*</span>投放规则：
              </span>
            </div>
            <div style={{ width: '70%' }}>
              <span style={{ lineHeight: '30px' }}>每天发送一次</span>
            </div>
          </div>

          {/* <div style={{ display: 'flex', marginBottom: '15px' }}>
            <div
              style={{
                width: '30%',
                height: '30px',
                lineHeight: '30px',
                textAlign: 'right',
                paddingRight: '10px',
              }}
            >
              <span>
                <span className={styles.mustFill}>*</span>投放策略：
              </span>
            </div>
            <div style={{ width: '70%' }}>
                <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                  <Radio
                    id="sms-push"
                    disabled={Number(props.checkType) === 3}
                    checked={+props.params.smsType === 1}
                    className={styles.rightNow}
                    style={{ marginRight: '10%' }}
                    onClick={() => {
                        setTypeDialogTip(true);
                    }}
                  >
                    短信投放
                  </Radio>
                  <Radio
                    id="rich-sms-push"
                    disabled={Number(props.checkType) === 3}
                    checked={+props.params.smsType === 2}
                    onClick={() => {
                        setTypeDialogTip(true);
                    }}
                  >
                    富信投放
                  </Radio>
                </div>
            </div>
          </div> */}
        </div>

        <div className={styles.baseInfoRight}>
          <div style={{ marginBottom: '25px' }}>
            <div style={{ display: 'flex', marginBottom: '5px' }}>
              <div
                className="iconfont icon-icon4-38"
                style={{ color: '#3399FF' }}
              />
              <div
                style={{
                  color: '#333333',
                  fontSize: '16px',
                  paddingLeft: '4px',
                }}
              >
                模型说明：
                <br />
              </div>
            </div>
            <div
              style={{
                paddingLeft: '20px',
                letterSpacing: '.5px',
                color: '#657180',
                lineHeight: '20px',
              }}
            >
              根据每个客户在店铺的历史购买和最后一次购买，计算出适用于每个客户的复购周期和下一次预计购买时间进行短信或富信推送，大大提升营销转化，促进客户复购
            </div>
          </div>
          <div>
            <div style={{ display: 'flex', marginBottom: '5px' }}>
              <div
                className="iconfont icon-icon4-38"
                style={{ color: '#3399FF' }}
              />
              <div
                style={{
                  color: '#333333',
                  fontSize: '16px',
                  paddingLeft: '4px',
                }}
              >
                短信发送注意事项：
                <br />
              </div>
            </div>
            <div
              style={{
                paddingLeft: '20px',
                letterSpacing: '.5px',
                color: '#657180',
                lineHeight: '20px',
              }}
            >
              1、短信发送时间范围为：早9:01-晚19:59（日常）。
              <br />
              2、请保证短信的余额充足，余额不足时会导致活动异常停止。
              <br />
              3、短信会按投放时间段的起始日期开始循环发送，若开始日期的当前时间不满足投放时间点，则以第二天作为第一次短信投放。
            </div>
          </div>
        </div>
      </div>

    {
        typeDialogTip &&
        <ConfirmDialog
            type="WARN"
            title="提示"
            promptInfo="切换类型后，将清空当前类型下所有投放内容的设置，确定切换？"
            flag={typeDialogTip}
            confirmHandel={changeType}
            cancelHandel={() => setTypeDialogTip(false)}
        />
    }
    </div>
  );
};

export default CheckInput;
